import api from '@/api/xhs/common.js'
const state = {
	
}
const mutations = {
	
}
const actions = {
	getClassCategoryAPI({ }, params = {}) {  // 小红书课程分类
        return api.getClassCategoryAPI(params)
    },
	getBrandAPI({ }, params = {}) {  
        return api.getBrandAPI(params)
    },
	uploadXhsPicAPI({ }, params = {}) {  
        return api.uploadXhsPicAPI(params)
    },
	getClassesListAPI({ }, params = {}) { 
        return api.getClassesListAPI(params)
    },
	handleClassAPI({ }, params = {}) {  
        return api.handleClassAPI(params)
    },
	classGroundingAPI({ }, params = {}) {  
        return api.classGroundingAPI(params)
    },
	updateStockAPI({ }, params = {}) {  
        return api.updateStockAPI(params)
    },
    getClassDetailInfoAPI({ }, params = {}) {  
        return api.getClassDetailInfoAPI(params)
    },
}
export default {
	namespaced:true,
	state,
	mutations,
	actions,
}